import styled from 'styled-components/macro';

import { AvatarWrapStyled } from 'components/Avatar/Avatar.styled';
import FlexContainer from 'components/FlexContainer/FlexContainer';
import Typography from 'components/Typography/Typography';

type ActionMessageStyledProps = {
  hasThumbnail?: boolean;
  isLoggedInUser?: boolean;
};

type MessageContentStyledProps = {
  isActionMessageContent?: boolean;
  hasThumbnail?: boolean;
  isLoggedInUser?: boolean;
};

export const MessagesWrapStyled = styled.div`
  min-width: 200px;
  width: 100%;
  max-height: 650px;
  height: 100%;
  overflow-y: auto;
  padding: 0.5rem 0.625rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: ${({ theme }) => `${theme.borders.xs} ${theme.colors.primary.variant5}`};
  border-radius: ${({ theme }) => theme.radius.xs};
`;

export const MessageWrapStyled = styled(FlexContainer)`
  &:not(:first-of-type) {
    margin-top: 1.5rem;
  }

  ${AvatarWrapStyled} {
    min-width: 32px;
  }
`;

export const FlexContainerStyled = styled(FlexContainer)<MessageContentStyledProps>`
  ${({ hasThumbnail, isLoggedInUser, theme }) =>
    hasThumbnail &&
    isLoggedInUser &&
    `
    margin-left: auto;
  `}
`;

export const MessageContentStyled = styled(FlexContainer)<MessageContentStyledProps>`
  flex-direction: column;
  align-items: start;
  margin-left: 0.375rem;

  ${({ isLoggedInUser }) => isLoggedInUser && `align-items: end;`}
  ${({ isActionMessageContent, theme }) =>
    isActionMessageContent &&
    `
      width: auto;
      align-items: center;
      padding: 6px 16px;
      background-color: ${theme.colors.secondary.variant3};
      border-radius: ${theme.radius.xl};
      `}

${({ hasThumbnail, isLoggedInUser, theme }) =>
    hasThumbnail &&
    isLoggedInUser &&
    `
      background: ${theme.colors.primary.variant14};
  `}
`;

export const MessageStyled = styled(Typography)<{ isText?: boolean; isLoggedInUser?: boolean }>`
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.colors.primary.variant11};
  word-break: break-word;
  white-space: pre-wrap;

  ${({ isText, isLoggedInUser, theme }) =>
    isText &&
    `
  width: auto;
  padding: 6px 16px;
  border-radius: ${theme.radius.xl};
  background-color: ${
    isLoggedInUser ? theme.colors.primary.variant14 : theme.colors.primary.variant3
  };
  ${isLoggedInUser ? 'margin-left: 20%;' : 'margin-right: 20%;'}
  `}
`;

export const ActionMessageStyled = styled(MessageStyled)<ActionMessageStyledProps>`
  margin: 0;
  ${({ isLoggedInUser, theme, hasThumbnail }) =>
    hasThumbnail &&
    `
    display: flex; 
    flex-direction: column; 
    gap: 4px;
    width: auto;
    padding: 6px 16px;
    border-radius: ${theme.radius.xl};
    background-color: ${
      isLoggedInUser ? theme.colors.primary.variant14 : theme.colors.primary.variant3
    };
  `}
`;

export const AttachmentNameStyled = styled.span`
  font-size: ${({ theme }) => theme.fontSize.lg};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

export const MessageSenderNameStyled = styled(Typography)`
  flex-shrink: 1;
  color: ${({ theme }) => theme.colors.primary.variant10};
  white-space: nowrap;
`;

export const ActionMessageSenderNameStyled = styled(MessageSenderNameStyled)`
  margin-right: 8px;
`;

export const MessageSentDateStyled = styled(Typography)`
  flex-shrink: 0;
  margin-left: 0.375rem;
  padding-top: 0.35rem;
  color: ${({ theme }) => theme.colors.primary.variant8};
`;

export const ActionMessageSentDateStyled = styled(MessageSentDateStyled)`
  margin: 0 0 5px 0;
`;

export const CountdownStyled = styled(Typography)`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.primary.variant8};
  margin-top: 0.25rem;

  ${({ theme }) => `
    ${theme.devices.tablet} {
      margin-right: 0.625rem;
      margin-top: 0;
      margin-left: 0.625rem;
      white-space: nowrap;
    }
  `}
`;

export const MessageOptionsWrapStyled = styled(FlexContainer)`
  margin-top: 0.625rem;
`;

export const AssignToWCToggleWrapStyled = styled(FlexContainer)`
  margin-right: 0.375rem;
`;

export const AssignToWCToggleTextStyled = styled(Typography)`
  color: ${({ theme }) => theme.colors.primary.variant1};
`;
